enum TranslationNamespaces {
	Root = 'Root',
	ClientSpaceList = 'ClientSpaceList',
	FlowList = 'FlowList',
	MainToolbar = 'MainToolbar',
	MainAppDrawer = 'MainAppDrawer',
	MainDashboard = 'MainDashboard',
	ClientSpace = 'ClientSpace',
	ProjectSpace = 'ProjectSpace',
	Integration = 'Integration',
	MainStepper = 'MainStepper',
	FlowView = 'FlowView',
	FlowMicroTaskList = 'FlowMicroTaskList',
	DataMapper = 'DataMapper',
	MicroTaskEditor = 'MicroTaskEditor',
	HubSpotCompanyClientService = 'HubSpotCompanyClientService',
	RestApiSender = 'RestApiSender',
	IfGateService = 'IfGateService',
	HubSpotWebhookService = 'HubSpotWebhookService',
	HubSpotContactClientService = 'HubSpotContactClientService',
	ShopifyWebhookService = 'ShopifyWebhookService',
	RestReceiver = 'RestReceiver',
	EditDiagramView = 'EditDiagramView',
	Variables = 'Variables',
	ArrayToRecordsTask = 'ArrayToRecordsTask',
	Unauthorized = 'Unauthorized',
	RequestAccessPage = 'RequestAccessPage',
	SecurityManagementView = 'SecurityManagementView',
}
export default TranslationNamespaces;
